export default {
  title: {
    tradeData: 'FiinTA',
    titleHeader: 'Dữ liệu giao dịch chuyên sâu cho Amibrokers',
  },
  button: {
    download: 'Tải xuống',
    userManual: 'Hướng Dẫn',
    historicalData: 'Cập nhật toàn bộ dữ liệu EOD lịch sử',
    realTimeData: 'Cập nhật liên tục dữ liệu real-time',
    dataEveryMinute: 'Cập nhật dữ liệu Intraday từng giây',
    pluginConnect: 'Kết nối bằng Plugin',
    comprehensiveData: 'Dữ liệu toàn diện - chuyên sâu',
    easyToUse: 'Tiện dụng',
  },
};
